import FormDevices from './form-devices.connect'
export default FormDevices
